const normalizeApiBaseUrl = (value: string | undefined, fallback: string): string => {
    const raw = (value || fallback).trim().replace(/\/+$/, '');
    if (!raw || raw.startsWith('/') || /^https?:\/\//i.test(raw)) {
        return raw;
    }
    return `https://${raw}`;
};

// Configurazione centralizzata per l'API .NET
export const API_CONFIG = {
    BASE_URL: normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL, 'https://localhost:5001'),
    ENDPOINTS: {
        // Users
        USERS: '/api/users',
        USERS_SYNC: '/api/users/sync',
        USERS_BY_FIREBASE_UID: (firebaseUid: string) => `/api/users/by-firebase-uid/${firebaseUid}`,
        USERS_UPDATE_PROFILE: (userId: number) => `/api/users/${userId}/profile`,

        // Connections
        // CONNECTIONS, CONNECTIONS_USER rimossi (2026-06-27): gli endpoint
        // persistence non esistono piu' lato server (tabella Connections
        // droppata). Le connessioni vivono nel local storage del client.
        CONNECTIONS_TEST: '/api/connections/test',
        CONNECTIONS_TOKEN: '/api/connections/token',

        // Tools
        TOOLS: '/api/tools',
        TOOLS_USER: (userId: number) => `/api/tools/user/${userId}`,
        TOOLS_ENABLE: (userId: number, toolId: number) => `/api/tools/user/${userId}/enable/${toolId}`,
        PLUGIN_MODULES: '/api/plugin-modules',

        // Dynamics
        DYNAMICS_PUBLISHERS: (connectionId: number) => `/api/dynamics/publishers?connectionId=${connectionId}`,
        DYNAMICS_SOLUTION: '/api/dynamics/solution',

        // Translation Drafts
        TRANSLATION_FORMDRAFTS: (connectionId: number, entityLogicalName: string) =>
            `/api/translation/formdrafts?connectionId=${connectionId}&entityLogicalName=${entityLogicalName}`,
        TRANSLATION_FORMDRAFT_BY_ID: (draftId: string) => `/api/translation/formdrafts/${draftId}`,
        TRANSLATION_FORMDRAFT_APPLY: (draftId: string) => `/api/translation/formdrafts/${draftId}/apply`,
    },
    TIMEOUT: 30000, // 30 secondi (default)
    TIMEOUT_MEDIUM: 60000, // 1 minuto (per operazioni medie)
    TIMEOUT_LONG: 120000, // 2 minuti (per operazioni lunghe con Dynamics 365)
    TIMEOUT_VERY_LONG: 600000, // 10 minuti (import/publish solution)
};

export default API_CONFIG;
